/* Clic sur « Passer la commande » quand le panier contient des échantillons (V23, 31/10/2026 ;
   V24, 02/11/2026 : contrôle aussi quand une surprise est due, même sans échantillon affiché) :
   1. CONTRÔLE : on relit le vrai panier et le droit recalculé par le site (window.odoEchVerifier, défini dans
      assets/echantillons-panier.js). Pas d'achat → les échantillons sont retirés et on ne part pas au paiement.
      Si une correction a été nécessaire (offert repassé en payant…), on réaffiche le panier corrigé au client
      au lieu de partir au paiement avec un prix qu'il n'a pas vu.
   2. ORDRE : d'abord les parfums, puis les échantillons payants, puis les offerts. Shopify garde l'ordre du
      panier dans la commande (fiche commande, facture, bordereau, back-office) et place en tête la dernière
      ligne ajoutée : si l'ordre n'est pas le bon, on retire puis on rajoute en tête, dans le bon ordre, les
      lignes qui doivent remonter (quantités et propriétés inchangées). */
(function () {
  if (window.__odoOrdreCommande) return;
  window.__odoOrdreCommande = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function post(path, data) {
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }

  function rang(item, freeId) {
    if (item.handle !== 'echantillon') return 0;
    return Number(item.variant_id) === freeId ? 2 : 1;
  }

  function remettreEnOrdre(freeId) {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = cart.items || [];
      var rangs = items.map(function (it) { return rang(it, freeId); });
      var enOrdre = rangs.every(function (r, i) { return i === 0 || rangs[i - 1] <= r; });
      if (enOrdre) return;
      var dernier = Math.max.apply(null, rangs);
      var aMonter = items.map(function (it, i) { return { it: it, i: i, r: rangs[i] }; })
        .filter(function (x) { return x.r < dernier; })
        .sort(function (a, b) { return a.r - b.r || a.i - b.i; })
        .map(function (x) { return x.it; });
      if (!aMonter.length) return;
      var retraits = {};
      aMonter.forEach(function (it) { retraits[it.key] = 0; });
      var ajouts = aMonter.map(function (it) {
        var o = { id: it.variant_id, quantity: it.quantity };
        if (it.properties && Object.keys(it.properties).length) o.properties = it.properties;
        if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) o.selling_plan = it.selling_plan_allocation.selling_plan.id;
        return o;
      }).reverse();
      return post('cart/update.js', { updates: retraits }).then(function () {
        return ajouts.reduce(function (p, o) { return p.then(function () { return post('cart/add.js', { items: [o] }); }); }, Promise.resolve());
      });
    });
  }

  function reafficher() {
    if (document.querySelector('[data-ech].ech--page')) { window.location.reload(); return; }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var btn = e.submitter;
    if (!form || !btn || btn.name !== 'checkout' || form.dataset.odoOrdre) return;
    var box = document.querySelector('[data-ech]');
    if (!box || (!box.querySelector('.ech__line') && !(Number(box.dataset.surprise) > 0))) return;
    var freeId = Number(box.dataset.free) || 0;
    if (!freeId) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.setAttribute('aria-busy', 'true');
    var verif = typeof window.odoEchVerifier === 'function' ? window.odoEchVerifier() : Promise.resolve({ achat: true, change: false });
    verif.then(function (res) {
      if (!res.achat || res.change || res.conforme === false) {
        btn.removeAttribute('aria-busy');
        reafficher();
        return 'stop';
      }
      return remettreEnOrdre(freeId);
    }).then(function (r) {
      if (r === 'stop') return;
      form.dataset.odoOrdre = '1';
      setTimeout(function () { delete form.dataset.odoOrdre; btn.removeAttribute('aria-busy'); }, 5000);
      if (form.requestSubmit) {
        form.requestSubmit(btn);
      } else {
        var h = document.createElement('input');
        h.type = 'hidden'; h.name = 'checkout'; h.value = btn.value || '';
        form.appendChild(h);
        form.submit();
      }
    }, function () {
      window.location.href = ROOT + 'cart';
    });
  }, true);

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('form[data-odo-ordre]').forEach(function (f) { delete f.dataset.odoOrdre; });
  });
})();
